import cloneDeep from 'lodash/cloneDeep'
import Image from '@/models-ts/Image'

export default class CompanyInfo {
  avatar: Image | null
  website: string
  companyName: string
  employees: string | null
  description: string
  countries: Array<{ id: number; name: string }>

  constructor({ avatar = null, website = '', description = '', companyName = '', employees = null, countries = [] }: Partial<CompanyInfo>) {
    Object.assign(
      this,
      cloneDeep({
        avatar,
        website,
        description,
        companyName,
        employees,
        countries,
      })
    )
  }

  static fromServer(props: LX.CompanyInfo) {
    return new CompanyInfo({
      avatar: Image.fromServer(props.relations.CompanyLogo),
      companyName: props.company_name || '',
      employees: props.employees || null,
      website: props.company_website || '',
      description: props.company_description || '',
      countries: (props.relations.Country || []).map((c) => ({ id: c.id, name: c.name })),
    })
  }

  toServer() {
    return {
      company_name: this.companyName.trim(),
      company_website: this.website.trim(),
      company_description: this.description.trim(),
      employees: this.employees || null,
      relations: {
        CompanyLogo: this.avatar?.toServer() || [],
        Country: this.countries.map((c) => ({ id: c.id })),
      },
    }
  }
}
